(() => {
  'use strict';
  if (window.lbBlueNavigationReady) return;
  window.lbBlueNavigationReady = true;

  const hoverDevice = window.matchMedia('(hover: hover) and (pointer: fine)');
  const hoverOpened = new WeakSet();

  const closeOthers = (current) => {
    document.querySelectorAll('[data-lb-header] details[open]').forEach((item) => {
      if (item !== current && !item.contains(current)) {
        item.open = false;
        hoverOpened.delete(item);
      }
    });
  };

  const init = (root) => {
    root.querySelectorAll('[data-lb-header] .lb-nav-dropdown').forEach((item) => {
      if (item.dataset.menuReady) return;
      item.dataset.menuReady = 'true';
      const summary = item.querySelector('summary');

      item.addEventListener('pointerenter', (event) => {
        if (event.pointerType !== 'mouse' || !hoverDevice.matches) return;
        closeOthers(item);
        if (!item.open) {
          hoverOpened.add(item);
          item.open = true;
        }
      });

      item.addEventListener('pointerleave', (event) => {
        if (event.pointerType !== 'mouse' || !hoverDevice.matches) return;
        if (item.contains(document.activeElement) && document.activeElement !== summary) return;
        hoverOpened.delete(item);
        item.open = false;
      });

      summary.addEventListener('click', (event) => {
        if (event.target.closest('a')) { event.stopPropagation(); return; }
        if (event.detail > 0 && item.open && hoverOpened.has(item)) event.preventDefault();
        hoverOpened.delete(item);
      });

      item.addEventListener('focusout', (event) => {
        if (!item.contains(event.relatedTarget)) {
          hoverOpened.delete(item);
          item.open = false;
        }
      });
    });
  };

  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));

  document.addEventListener('click', (event) => {
    document.querySelectorAll('[data-lb-header] details[open]').forEach((item) => {
      if (!item.contains(event.target)) {
        item.open = false;
        hoverOpened.delete(item);
      }
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const opened = [...document.querySelectorAll('[data-lb-header] details[open]')];
    opened.forEach((item) => {
      item.open = false;
      hoverOpened.delete(item);
    });
    if (opened.length) opened[0].querySelector('summary')?.focus();
  });

  document.addEventListener('toggle', (event) => {
    const item = event.target;
    if (!(item instanceof HTMLDetailsElement) || !item.open || !item.closest('[data-lb-header]')) return;
    closeOthers(item);
  }, true);
})();
